import { Box, Divider, Flex, Img, Link, Text } from '@chakra-ui/react';
import React from 'react';
import {
  FaInstagramSquare,
  FaTwitterSquare,
  FaYoutubeSquare,
} from 'react-icons/fa';
import { FaSquareFacebook } from 'react-icons/fa6';
import { PiPhoneFill } from 'react-icons/pi';

/**
 * Footer component.
 * @component
 * @returns {React.FC} Footer component
 * @author Bagas Prasetyadi
 */

const Footer: React.FC = () => {
  const logoFooterLeft = localStorage.getItem('logoFooterLeft') ?? '';
  const logoFooterCenter = localStorage.getItem('logoFooterCenter') ?? '';
  const contact = localStorage.getItem('contact') ?? '';
  const urlInstagram = localStorage.getItem('urlInstagram') ?? '';
  const urlFacebook = localStorage.getItem('urlFacebook') ?? '';
  const urlTwitter = localStorage.getItem('urlTwitter') ?? '';
  const urlYoutube = localStorage.getItem('urlYoutube') ?? '';
  const copyright = localStorage.getItem('copyright') ?? '';

  return (
    <Box
      style={{
        background:
          'linear-gradient(83.57deg, #16A34A 68.79%, #E2FF7D 113.39%)',
      }}
      w="full"
      pt={8}
      pb={20}
      px={{ base: 8, md: 12 }}
    >
      {/* dekstop screen */}
      <Box
        justifyContent="space-between"
        mt={{ md: 4 }}
        alignItems="center"
        flexDirection={{ base: 'column', md: 'row' }}
        display={{ base: 'none', md: 'flex' }}
      >
        <Box mt={4}>
          <Flex
            alignItems="center"
            justifyContent="center"
            h="full"
            className="gap-4"
          >
            <Img src={logoFooterLeft} h="3rem" w="auto" objectFit="contain" />
            <Box className="border-r border-white h-8"></Box>
            <Img w="auto" h="3rem" src={logoFooterCenter} objectFit="contain" />
          </Flex>
        </Box>
        <Box mt={4} display="flex" justifyContent={{ md: 'flex-end' }}>
          <Text fontSize="2xl" fontWeight="semibold" color="white">
            “Belajar Mandiri, Pintar Bersama”
          </Text>
        </Box>
      </Box>

      {/* mobile screen */}
      <Box display={{ base: 'block', md: 'none' }}>
        <Flex
          alignItems="center"
          justifyContent="start"
          h="full"
          className="gap-4"
        >
          <Img src={logoFooterLeft} h="1.5rem" w="auto" objectFit="contain" />
          <Box className="border-r border-white h-8"></Box>
          <Img w="auto" h="1.5rem" src={logoFooterCenter} objectFit="contain" />
        </Flex>
      </Box>

      <Divider my={4} />

      {/* desktop screen */}
      <Box
        flexDirection={{ base: 'column', md: 'row' }}
        display={{ base: 'none', md: 'flex' }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="row"
          className="gap-4"
          alignItems="center"
        >
          <Box display="flex" flexDirection="row" className="gap-2">
            <PiPhoneFill size={14} color="white" className="mt-1" />
            <Box display="flex" flexDirection="column">
              <Text color="white">Hubungi Kami</Text>
              <Text fontSize="lg" fontWeight="medium" color="white">
                {contact}
              </Text>
            </Box>
          </Box>
          <Box className="border-r border-white h-8"></Box>
          <Flex justifyContent={{ base: 'start', md: 'center' }}>
            <Link mr={2} href={urlFacebook} isExternal>
              <FaSquareFacebook color="white" size={20} />
            </Link>
            <Link mr={2} href={urlInstagram} isExternal>
              <FaInstagramSquare color="white" size={20} />
            </Link>
            <Link mr={2} href={urlYoutube} isExternal>
              <FaYoutubeSquare color="white" size={20} />
            </Link>
            <Link mr={2} href={urlTwitter} isExternal>
              <FaTwitterSquare color="white" size={20} />
            </Link>
          </Flex>
        </Box>
        <Flex direction="column">
          <Flex direction="row" className="gap-4 text-white mb-4 justify-end">
            <Link href="/privacy-policy" className="border-r border-white pr-4">
              <p className="underline">Privacy & Policy</p>
            </Link>
            <Link href="/request-delete-account">
              <p className="underline">Request Delete Account</p>
            </Link>
          </Flex>
          <Text color="white" fontSize={{ base: '11px', md: 'sm' }}>
            © {copyright}
          </Text>
        </Flex>
      </Box>

      {/* mobile screen */}
      <Box display={{ base: 'block', md: 'none' }}>
        <Box
          display="flex"
          flexDirection="row"
          className="gap-4"
          alignItems="center"
        >
          <Box display="flex" flexDirection="row" className="gap-2">
            <PiPhoneFill size={14} color="white" className="mt-1" />
            <Box display="flex" flexDirection="column">
              <Text color="white">Hubungi Kami</Text>
              <Text fontSize="lg" fontWeight="medium" color="white">
                {contact}
              </Text>
            </Box>
          </Box>
          <Box className="border-r border-white h-8"></Box>
          <Flex>
            <Link mr={8} href={urlFacebook} isExternal>
              <FaSquareFacebook color="white" size={20} />
            </Link>
            <Link mr={8} href={urlInstagram} isExternal>
              <FaInstagramSquare color="white" size={20} />
            </Link>
            <Link mr={8} href={urlYoutube} isExternal>
              <FaYoutubeSquare color="white" size={20} />
            </Link>
            <Link mr={8} href={urlTwitter} isExternal>
              <FaTwitterSquare color="white" size={20} />
            </Link>
          </Flex>
        </Box>
        <Text
          color="white"
          fontSize={{ base: '11px', md: 'sm' }}
          className="mt-8 -mb-8"
        >
          © {copyright}
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
